import { Subscription } from 'rxjs';
import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';

import { InteractivityEditorService } from '../../services/interactivity-editor.service';

@Component({
	selector: 'time-ruler',
	templateUrl: './time-ruler.component.html',
	styleUrls: ['./time-ruler.component.scss']
})

export class TimeRulerComponent implements OnInit, OnDestroy {
	@ViewChild('canvas', { static: true }) canvas: ElementRef;

	private duration = 180; // default clip duration
	private subscriptions: Subscription = new Subscription();
	private zoomFactor: number;
	private PIXEL_RATIO: number;

	constructor(
		private el: ElementRef,
		private interactivityEditorService: InteractivityEditorService
	) {
		this.PIXEL_RATIO = (() => {
			const ctx = document.createElement('canvas').getContext('2d') as any;
			const dpr = window.devicePixelRatio || 1;
			const bsr = ctx.webkitBackingStorePixelRatio ||
				ctx.mozBackingStorePixelRatio ||
				ctx.msBackingStorePixelRatio ||
				ctx.oBackingStorePixelRatio ||
				ctx.backingStorePixelRatio || 1;
			return dpr / bsr;
		})();
	}

	ngOnInit() {
		this.subscriptions.add(this.interactivityEditorService.durationSubject.subscribe(
			(duration: number) => {
				this.duration = duration;
				this.draw();
			}));
		this.subscriptions.add(this.interactivityEditorService.trackZoomSubject.subscribe((trackZoom: any) => {
			if (trackZoom && trackZoom.zoomFactor && trackZoom.zoomFactor !== this.zoomFactor) {
				this.draw();
				this.zoomFactor = trackZoom.zoomFactor;
			}
		}));
		this.draw();
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	onResize() {
		this.draw();
	}

	private draw(): void {
		const context = this.canvas.nativeElement.getContext('2d');
		context.setTransform(this.PIXEL_RATIO, 0, 0, this.PIXEL_RATIO, 0, 0);
		// let percentageBased: boolean = false;	// for now

		const elWidth = this.el.nativeElement.offsetWidth;
		const elHeight = this.el.nativeElement.offsetHeight;
		// erase canvas by setting size;
		context.canvas.width = elWidth * this.PIXEL_RATIO;
		context.canvas.height = elHeight * this.PIXEL_RATIO;

		let interval = 0;
		let numLines = 1;
		const numLinesBetween = 9;
		do {
			interval = (interval < 1) ? 1 :
				(interval < 5) ? 5 :
					(interval < 15) ? 15 :
						(interval < 30) ? 30 :
							(interval < 60) ? 60 :
								(interval < 300) ? 300 :
									(interval < 900) ? 900 :
										(interval < 1800) ? 1800 :
											(interval < 3600) ? 3600 : -1;
			if (interval > 0) {
				numLines = Math.round(this.duration / interval);
			}
			if ((elWidth / numLines) >= 36) {
				break;
			}
		} while (interval > 0);

		context.strokeStyle = '#aaaaaa';
		context.font = 9 * this.PIXEL_RATIO + 'px sans-serif';
		context.fillStyle = '#aaaaaa';
		context.textAlign = 'center';
		context.textBaseline = 'top';
		context.beginPath();


		for (let i = 0; i < numLines + 1; i++) {
			const spaceBetween = (interval / this.duration) * context.canvas.width;
			const toXPos: number = i * spaceBetween;
			// let label: string = '';

			// if ( percentageBased ) {
			// 	label = String( Math.round( ( i * interval ) / this.duration * 100)) + '%';
			// } else {
			// 	label = String( i * interval );
			// }

			context.moveTo(toXPos, context.canvas.height / 2);
			context.lineTo(toXPos, context.canvas.height - (4 * this.PIXEL_RATIO));
			context.fillText(this.formatTime(this.duration, i * interval, false), toXPos, 5 * this.PIXEL_RATIO);

			for (let j = 1; j <= numLinesBetween; j++) {
				context.moveTo(toXPos + (j * (spaceBetween / (numLinesBetween + 1))), context.canvas.height - (10 * this.PIXEL_RATIO));
				context.lineTo(toXPos + (j * (spaceBetween / (numLinesBetween + 1))), context.canvas.height - (4 * this.PIXEL_RATIO));
			}
		}

		// end line full height:
		context.moveTo(context.canvas.width, 0);
		context.lineTo(context.canvas.width, context.canvas.height);
		context.stroke();
	}

	private formatTime(duration: number, p_time: number, showMs: boolean = true, alwaysShowMinutes: boolean = true): string {
		const h = Math.floor(p_time / 3600);
		const m = Math.floor((p_time - (h * 3600)) / 60);
		const s = Math.floor((p_time - (h * 3600)) % 60);
		const ms = Math.round((((p_time - (h * 3600)) % 60) - Math.floor((p_time - (h * 3600)) % 60)) * 100);

		let time = '';

		if (h > 0) {
			time += this.fillZero(String(h)) + ':';
		}

		if (m > 0) {
			time += this.fillZero(String(m)) + ':';
			// if ( h > 0 ) {
			// 	time += this.fillZero(String(m)) + ':';
			// } else {
			// 	time += String(m) + ':';
			// }
		} else {
			if (duration > 60 || alwaysShowMinutes) {
				time += '00:';
			}
		}

		if (s > 0) {
			time += this.fillZero(String(s));
		} else {
			time += '00';
		}

		if (showMs) {
			if (ms > 0) {
				time += '.' + this.fillZero(String(ms));
			} else {
				time += '.00';
			}
		}
		return time;
	}

	private fillZero(p: string): string {
		if (p.length === 1) {
			return '0' + p;
		} else {
			return p;
		}
	}

}
